 var sections = $('.first-section');
  var dataattr =  $('.first_margin').attr("data");
var dataattrt =  $('.second_margin').attr("data");
var dataattrth =  $('.third_margin').attr("data");
var dataattrf =  $('.fourth_margin').attr("data");
        var years = [dataattr, dataattrt, dataattrth, dataattrf];
        var sectionYears = {};

        function updateClipPath() {
            var windowHeight = $(window).height();
            var scrollTop = $(window).scrollTop();

            sections.each(function (index) {
                var sectionOffsetTop = $(this).offset().top;
                if (scrollTop >= sectionOffsetTop - windowHeight * 0.7 && scrollTop < (index === sections.length - 1 ? Infinity : sections.eq(index + 1).offset().top - windowHeight * 0.7)) {
                    $('.year, .year-overlay').text(sectionYears[index]);
                }
            });
        }

        // Initialize sectionYears with corresponding years
        sections.each(function (index) {
            sectionYears[index] = years[index];
        });

        // Add the scroll event listener
        $(window).scroll(function () {
            updateClipPath();
        });

        // Call updateClipPath on page load
        $(document).ready(function () {
            updateClipPath();
        });







 function updateClipPathReveal(innerElement, scrollTop) {
            var innerOffsetTop = $(innerElement).offset().top;
            var innerOffsetBottom = innerOffsetTop + $(innerElement).outerHeight();
            var yearOffsetTop = $('.year').offset().top;
            var windowHeight = $(window).height();
            var scrollTop = $(window).scrollTop();
            var revealOffsetTop = innerOffsetTop - windowHeight * 0.6; // Adjust the value to control the reveal point (40% into the screen)
            var emptyOffsetTop = innerOffsetBottom - windowHeight * 0.3; // Adjust the value to control when the number becomes empty (30% before center)
            var fillOffsetTop = innerOffsetBottom - windowHeight * 0.6; // Adjust the value to control when the number starts filling (60% before center)
            var fullOffsetTop = yearOffsetTop + $('.year').outerHeight(); // Adjust the value to control when the number is fully filled

            // Calculate the clip path value based on the scroll position for filling
            var fillClipValue = 81;
            if (scrollTop >= revealOffsetTop && scrollTop <= emptyOffsetTop) {
                fillClipValue = 81 - ((scrollTop - revealOffsetTop) / ($('.inner').outerHeight() * 0.6)) * 100;
                $('.year-overlay').css('clip-path', 'inset(' + fillClipValue + '% 0px 0px 0px)');
            } else if (scrollTop > emptyOffsetTop && scrollTop <= fillOffsetTop) {
                fillClipValue = 20 + ((scrollTop - emptyOffsetTop) / ($('.inner').outerHeight() * 0.6)) * 100;
                $('.year-overlay').css('clip-path', 'inset(' + fillClipValue + '% 0px 0px 0px)');
            }

            // Calculate the clip path value based on the scroll position for emptying
            var emptyClipValue = 19;
            if (scrollTop > fillOffsetTop && scrollTop <= fullOffsetTop) {
                emptyClipValue = 19 + ((scrollTop - fillOffsetTop) / ($('.year').outerHeight() * 0.35)) * 62;
                $('.year-overlay').css('clip-path', 'inset(0px 0px ' + emptyClipValue + '% 0px)');
            }
        }

        function applyUpdateClipPathToAllInner() {
            var scrollTop = $(window).scrollTop();
            var lastInnerElement = null;
            $('.inner').each(function () {
                updateClipPathReveal(this, scrollTop);
                lastInnerElement = this; // Keep updating the last .inner element in the loop
            });
            // Add the class to .center-section when the last .first-section .inner element is 100% into the viewport
            var viewportHeight = $(window).height();
            var lastInnerOffset = $(lastInnerElement).offset().top;
            // var revealOffsetTop = lastInnerOffset - viewportHeight * 0.5; // 100% into the viewport
            var revealOffsetTop = (lastInnerOffset - viewportHeight * 0.5) + 180;
            var revealOffsetTopPixels = revealOffsetTop + 'px';
            if (scrollTop >= revealOffsetTop) {
                $('.last-year').addClass('lastDiplay');
                $('.center-section').addClass('your-desired-class-name');
            } else {
                $('.last-year').removeClass('lastDiplay');
                $('.center-section').removeClass('your-desired-class-name');
            }
        }

        // Add the scroll event listener
        $(window).scroll(function () {
            applyUpdateClipPathToAllInner();
        });

        // Call applyUpdateClipPathToAllInner on page load
        $(document).ready(function () {
            applyUpdateClipPathToAllInner();
        });
  